import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const PlayerIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 11.999 17.037"
    >
      <g transform="translate(1 1.019)">
        <path
          d="M905.578,6.145l8.679,6.86a.626.626,0,0,1,0,.989l-8.679,6.86a.662.662,0,0,1-1.078-.494V6.639A.662.662,0,0,1,905.578,6.145Z"
          transform="translate(-904.5 -6)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
